import { createSlice } from "@reduxjs/toolkit";

const initalState = {
  viewOnlyMode: false,
  reqLCustomerId: null,
  reqLPlantId: null,
  reqCustomerName: "",
  reqMultiConsignee: 2,
  reqConsignmentType: 2,
  reqQty: null,
  reqUom: null,
  reqCbm: null,
  reqCbmUom: null,
  reqConfirmationStatus: 1,
  reqCreationType: 1,
  reqBookingRequiredDate: null,
  tempBookingRequiredDate: null,
  startArrivalTime : "",
  reqVehicleTypeId: null,
  startETA: null,
  locationPositions: [],
  requestLocationsRequests: [
    {
      rlkLocation: null,
      rlkLocationType: 1,
      rlkArrivalEta: "",
      rlkDepartureEta: "",
      rlkSeq: 1,
      rlkActive: 1,
      requestConsigneesRequests: [],
    },
    {
      rlkLocation: null,
      rlkLocationType: 2,
      rlkArrivalEta: "",
      rlkDepartureEta: "",
      rlkActive: 1,
      requestConsigneesRequests: [],
    },
  ],
  requestConsigneesRequests: [],
  requestOtherRequests: [],
  requestMultipleJobs: [],
  startLocationErrors: {},
  endLocationErrors: {},
  validationErrors: [],
  consigneeValidationErrors: [],
  requestInitErrors: {},
  requestTransporterErrors: {},
  requestConsigneeErrors: {},
  requestSummaryErrors: {},
  requestOtherErrors: {},
  hasLocErrors: true,
  hasConErrors: false,
  submitted: false,
  vehicleMaxCbm: 0,
  editMode: false,
  currentValues: {},
  editModeOtherCount: 0,
  singleConsignee: null,
  allowSameLocations: false,
  sameLocationAllowedCheckLoading: false,
};

const requestSlice = createSlice({
  name: "request",
  initialState: initalState,
  reducers: {
    setAllowSameLocations: (state, action) => {
      return { ...state, allowSameLocations: action.payload };
    },
    setSameLocationCheckLoading(state, action) {
      return { ...state, sameLocationAllowedCheckLoading: action.payload };
    },
    setRequest(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetRequest() {
      return initalState;
    },
    addTransportError(state, action) {
      return {
        ...state,
        requestTransporterErrors: {
          ...state.requestTransporterErrors,
          [action.payload.key]: action.payload.value,
        },
      };
    },
    removeTransportError(state, action) {
      const { [action.payload.key]: _, ...rest } =
        state.requestTransporterErrors;
      return {
        ...state,
        requestTransporterErrors: rest,
      };
    },
    setCurrentValues(state, action) {
      return {
        ...state,
        currentValues: {
          ...state.currentValues,
          ...action.payload,
        },
      };
    },
    resetErrors(state) {
      return {
        ...state,
        startLocationErrors: {},
        endLocationErrors: {},
        validationErrors: [],
        consigneeValidationErrors: [],
        requestInitErrors: {},
        requestTransporterErrors: {},
        requestConsigneeErrors: {},
        requestSummaryErrors: {},
        requestOtherErrors: {},
        hasLocErrors: true,
        hasConErrors: false,
        submitted: true,
      };
    },
    setSingleConsignee(state, action) {
      return {
        ...state,
        singleConsignee: {
          ...state.singleConsignee,
          ...action.payload,
        },
      };
    },
    setStartLocation(state, action) {
      return {
        ...state,
        requestLocationsRequests: state.requestLocationsRequests.map((item) => {
          if (item.rlkLocationType === 1) {
            return {
              ...item,
              ...action.payload,
            };
          }
          return item;
        }),
      };
    },
    setEndLocation(state, action) {
      return {
        ...state,
        requestLocationsRequests: state.requestLocationsRequests.map((item) => {
          if (item.rlkLocationType === 2) {
            return {
              ...item,
              ...action.payload,
            };
          }
          return item;
        }),
      };
    },
    addLocation(state, action) {
      return {
        ...state,
        requestLocationsRequests: [
          ...state.requestLocationsRequests,
          action.payload,
        ],
      };
    },
    updateLocations(state, action) {
      const startLocation = state.requestLocationsRequests.find(
        (location) => location.rlkLocationType === 1,
      );
      const endLocation = state.requestLocationsRequests.find(
        (location) => location.rlkLocationType === 2,
      );
      return {
        ...state,
        requestLocationsRequests: [
          ...action.payload,
          startLocation,
          endLocation,
        ],
      };
    },
    updateNonPersistedLocation(state, action) {
      return {
        ...state,
        requestLocationsRequests: state.requestLocationsRequests.map((item) => {
          if (item.id === action.payload.id) {
            return {
              ...item,
              ...action.payload.location,
            };
          }
          return item;
        }),
      };
    },
    updatePersistedLocation(state, action) {
      return {
        ...state,
        requestLocationsRequests: state.requestLocationsRequests.map((item) => {
          if (item.rlkId === action.payload.rlkId) {
            return {
              ...item,
              ...action.payload.location,
            };
          }
          return item;
        }),
      };
    },
    removeLocation(state, action) {
      return {
        ...state,
        requestLocationsRequests: state.requestLocationsRequests.map((item) => {
          if (item.rlkId === action.payload.rlkId) {
            return {
              ...item,
              rlkActive: 2,
            };
          }
          return item;
        }),
        requestConsigneesRequests: state.requestConsigneesRequests.map(
          (item) => {
            if (parseInt(item.rcoLocation) === action.payload.location) {
              return {
                ...item,
                rcoActive: 2,
              };
            }
            return item;
          },
        ),
      };
    },
    removeUnPersistedLocation(state, action) {
      return {
        ...state,
        requestLocationsRequests: state.requestLocationsRequests.filter(
          (item) => item.id !== action.payload.id,
        ),
        requestConsigneesRequests: state.requestConsigneesRequests.map(
          (item) => {
            if (parseInt(item.rcoLocation) === action.payload.location) {
              return {
                ...item,
                rcoActive: 2,
              };
            }
            return item;
          },
        ),
      };
    },
    setConsignees(state, action) {
      return {
        ...state,
        requestConsigneesRequests: action.payload,
      };
    },
    addConsignee(state, action) {
      return {
        ...state,
        requestConsigneesRequests: [
          ...state.requestConsigneesRequests,
          action.payload,
        ],
      };
    },
    updateNonPersistedConsignee(state, action) {
      return {
        ...state,
        requestConsigneesRequests: state.requestConsigneesRequests.map(
          (item) => {
            if (item.id === action.payload.id) {
              return {
                ...item,
                ...action.payload.consignee,
              };
            }
            return item;
          },
        ),
      };
    },
    updatePersistedConsignee(state, action) {
      return {
        ...state,
        requestConsigneesRequests: state.requestConsigneesRequests.map(
          (item) => {
            if (item.rcoId === action.payload.rcoId) {
              return {
                ...item,
                ...action.payload.consignee,
              };
            }
            return item;
          },
        ),
      };
    },
    removeConsignee(state, action) {
      return {
        ...state,
        requestConsigneesRequests: state.requestConsigneesRequests.map(
          (item) => {
            if (item.rcoId === action.payload.rcoId) {
              return {
                ...item,
                rcoActive: 2,
              };
            }
            return item;
          },
        ),
      };
    },
    removeUnPersistedConsignee(state, action) {
      return {
        ...state,
        requestConsigneesRequests: state.requestConsigneesRequests.map(
          (item) => {
            if (item.id === action.payload.id) {
              return {
                ...item,
                rcoActive: 2,
              };
            }
            return item;
          },
        ),
      };
    },
    setOther(state, action) {
      return {
        ...state,
        requestOtherRequests: action.payload,
      };
    },
    addOther(state, action) {
      return {
        ...state,
        requestOtherRequests: [...state.requestOtherRequests, action.payload],
      };
    },
    updatePersistedOther(state, action) {
      return {
        ...state,
        requestOtherRequests: state.requestOtherRequests.map((item) => {
          if (item.rotId === action.payload.rotId) {
            return {
              ...item,
              ...action.payload.other,
            };
          }
          return item;
        }),
      };
    },
    updateNonPersistedOther(state, action) {
      return {
        ...state,
        requestOtherRequests: state.requestOtherRequests.map((item) => {
          if (item.id === action.payload.id) {
            return {
              ...item,
              ...action.payload.other,
            };
          }
          return item;
        }),
      };
    },
    removeOther(state, action) {
      return {
        ...state,
        requestOtherRequests: state.requestOtherRequests.map((item) => {
          if (item.rotId === action.payload.rotId) {
            return {
              ...item,
              rotActive: 2,
            };
          }
          return item;
        }),
      };
    },
    removeNonPersistedOther(state, action) {
      return {
        ...state,
        requestOtherRequests: state.requestOtherRequests.map((item) => {
          if (item.id === action.payload.id) {
            return {
              ...item,
              rotActive: 2,
            };
          }
          return item;
        }),
      };
    },
    addRequestMultipleJobs(state, action) {
      return {
        ...state,
        requestMultipleJobs: [...state.requestMultipleJobs, action.payload],
      };
    },
    setRequestMultipleJobs(state, action) {
      return {
        ...state,
        requestMultipleJobs: action.payload,
      };
    },
    updatePersistedRequestMultipleJobs(state, action) {
      return {
        ...state,
        requestMultipleJobs: state.requestMultipleJobs.map((item) => {
          if (item.rmjId === action.payload.rmjId) {
            return {
              ...item,
              ...action.payload.requestMultipleJob,
            };
          }
          return item;
        }),
      };
    },
    updateNonPersistedRequestMultipleJobs(state, action) {
      return {
        ...state,
        requestMultipleJobs: state.requestMultipleJobs.map((item) => {
          if (item.id === action.payload.id) {
            return {
              ...item,
              ...action.payload.requestMultipleJob,
            };
          }
          return item;
        }),
      };
    },
    removePersistedRequestMultipleJobs(state, action) {
      return {
        ...state,
        requestMultipleJobs: state.requestMultipleJobs.map((item) => {
          if (item.rmjId === action.payload.rmjId) {
            return {
              ...item,
              rmjActive: 2,
            };
          }
          return item;
        }),
      };
    },
    removeNonPersistedRequestMultipleJobs(state, action) {
      return {
        ...state,
        requestMultipleJobs: state.requestMultipleJobs.map((item) => {
          if (item.id === action.payload.id) {
            return {
              ...item,
              rmjActive: 2,
            };
          }
          return item;
        }),
      };
    },
    clearRequestMultipleJobs(state) {
      return {
        ...state,
        requestMultipleJobs: [],
      };
    },
  },

  extraReducers(builder) {},
});

export const requestActions = requestSlice.actions;
export default requestSlice;
